import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./style/main.scss";
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
import { CountDown } from "vant";
import { emoji } from "./utils/emoji.js";
import filterHtml from "./common/methods/filterHtml.js"
Vue.prototype.emoji = emoji;
Vue.prototype.$filterHtml = filterHtml;
Vue.use(CountDown);
Vue.use(ElementUI);
Vue.config.productionTip = false;
let isMobile = false;
if (
  navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
) {
  window.location.href = window.location.href.replace(/pc/, "mobile");
  isMobile = true
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
// 初始化
// import '@/config/init.js'
Vue.prototype.$isMobile = isMobile;